import { useEffect } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'RoofingContractor',
  name: 'Garden State Roofing Co.',
  url: SITE_URL,
  telephone: '+18566776191',
  email: 'info@gardenstaterooofing.com',
  logo: `${SITE_URL}/favicon.png`,
  image: `${SITE_URL}/favicon.png`,
  description:
    'Certified commercial flat roofing specialists with a licensed engineer on staff serving all of New Jersey and Pennsylvania. GAF, Tamko, Owens Corning certified. 24-hour emergency service.',
  priceRange: '$$',
  address: {
    '@type': 'PostalAddress',
    addressRegion: 'NJ',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 39.8,
    longitude: -74.95,
  },
  areaServed: [
    { '@type': 'State', name: 'New Jersey' },
    { '@type': 'State', name: 'Pennsylvania' },
  ],
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '07:00',
      closes: '18:00',
    },
  ],
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+18566776191',
      contactType: 'customer service',
      areaServed: ['NJ', 'PA'],
      availableLanguage: 'English',
    },
    {
      '@type': 'ContactPoint',
      telephone: '+18566776191',
      contactType: 'emergency',
      hoursAvailable: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '00:00',
        closes: '23:59',
      },
    },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Commercial Flat Roofing Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'TPO Roofing Systems',
          description:
            'Thermoplastic Polyolefin single-ply membranes offering outstanding energy efficiency, heat-welded seams, and UV/chemical/puncture resistance for NJ commercial properties.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'EPDM Rubber Roofing',
          description:
            'Highly durable synthetic rubber membrane for large commercial flat roofs with excellent resistance to extreme NJ weather conditions.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Modified Bitumen Roofing',
          description:
            'Proven asphalt-based roofing system reinforced with polyester or fiberglass for superior waterproofing on commercial flat roofs.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Emergency Roof Repair',
          description:
            '24-hour emergency roof repair response across all of New Jersey to stop leaks fast and prevent costly interior damage.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Roof Coatings & Restoration',
          description:
            'Elastomeric and silicone roof coatings that extend the life of existing flat roofs — a cost-effective alternative to full replacement.',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Roof Inspections',
          description:
            'On-staff engineer performs thorough structural and waterproofing assessments with detailed inspection reports for NJ commercial buildings.',
        },
      },
    ],
  },
  sameAs: [],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Garden State Roofing Co.',
  url: SITE_URL,
  description:
    'NJ & PA commercial flat roofing company. Certified specialists in TPO, EPDM, modified bitumen roofing with a licensed engineer on staff.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function SeoJsonLd() {
  useEffect(() => {
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement('script');
        el.id = id;
        (el as HTMLScriptElement).type = 'application/ld+json';
        document.head.appendChild(el);
      }
      el.textContent = JSON.stringify(data);
    };

    injectSchema('schema-local-business', localBusinessSchema);
    injectSchema('schema-website', websiteSchema);

    return () => {
      ['schema-local-business', 'schema-website'].forEach((id) => {
        document.getElementById(id)?.remove();
      });
    };
  }, []);

  return null;
}
